import { Outlet, ScrollRestoration } from 'react-router';
import { ToastProvider } from '@/components/ui';
import { AuthProvider } from '@/features/auth';
import { ServiceBanner } from '@/features/status';

/** Root route element: providers that need router context, and the site-wide "server unreachable" bar. */
export function RootProviders() {
  return (
    <ToastProvider>
      <AuthProvider>
        <ServiceBanner />
        <Outlet />
        <ScrollRestoration />
      </AuthProvider>
    </ToastProvider>
  );
}
